import classNames from 'classnames'
import { usePage } from '~/hooks'
import { CountryCode, Product } from '~/types'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '../../../components/Typography'
import styles from './ProductDashboardGuarantee.module.scss'

export interface ProductDashboardGuaranteeProps {
  product: Product
}

export const ProductDashboardGuarantee = ({
  product,
}: ProductDashboardGuaranteeProps) => {
  const { countryCode } = usePage()
  const isAu = countryCode === CountryCode.AU

  return (
    <div className={classNames(styles.root, 'mt-5')}>
      <Typography
        variant={TypographyVariant.BodySmall}
        tag={TypographyTag.div}
        className={classNames(
          styles.trustInfo,
          'flex items-center justify-center'
        )}>
        <div>30-Day Returns</div>
        <div>{isAu ? 'Australian Stock' : 'New Zealand Stock'}</div>
        <div>Warranty Included</div>
      </Typography>
    </div>
  )
}
